import { Heading, Text } from "@sentricmusic/ui";
import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useGetUserMeta } from "@/api/queries";
import AuthPrimaryButton from "@/components/AuthPrimaryButton";
import Spacer from "@/components/Spacer";
// import AppState from "@/store/appstate";
import useAppStore from "@/store/appStateZustand";

function ResetPasswordSuccess() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // const username = AppState.useState(s => s?.authentication.userName);
  const username = useAppStore(s => s.authentication?.userName);
  const userMeta = useGetUserMeta();
  const [pending, setPending] = useState(false);

  const goDashboard = () => {
    setPending(true);
    userMeta.refetch();
    setTimeout(() => {
      navigate({ to: "/" });
    }, 3000);
  };

  return (
    <div>
      <div className="container mx-auto">
        <div className="flex flex-col items-center justify-center p-4 text-center min-h-screen-minus-footer">
          <Heading as="h1" className="text-white">{t("auth:password-reset-success-header")}</Heading>
          <div className="w-full text-white lg:w-2/3">
            <Spacer />
            <Text as="bodyLg" className="text-white">
              {t("auth:your-username")}
              {" "}
              <b>{username}</b>
            </Text>
            <Spacer thin />
            <Text as="bodyLg" className="text-white">
              {t("auth:use-this-login-button")}
            </Text>
            <Spacer />
            <AuthPrimaryButton
              disabled={pending}
              pending={pending}
              onClick={goDashboard}
            >
              {t("common:login")}
            </AuthPrimaryButton>
          </div>

        </div>
      </div>
    </div>
  );
}

export default ResetPasswordSuccess;
